import React from 'react';
import styled from 'styled-components';

const Req = styled.span`
  font-size: 1.25rem;
  font-weight: bold;
  color: red;
  margin-left: 3px;
`;

const Required = () => <Req>*</Req>;

export default Required;
